// PounceAgentDetail ke components ke saanjhe helpers (dates, phone, chart data).
export const RANGES = [
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "7d", label: "Last 7 days" },
  { key: "30d", label: "Last 30 days" },
];

export const PLAN_LABELS = { payg: "Pay As You Go", subscribe: "Outbound Caller Pro" };
// A lead-deal subscription (the default plan) is Outbound Caller Pro; others keep their name.
export const planLabel = (plan, deal) => (deal ? "Outbound Caller Pro" : PLAN_LABELS[plan]);

export const DAY_MS = 24 * 60 * 60 * 1000;

export const startOfDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

// Viewer ke local din ke hisaab se range — server ka timezone user ka nahi.
export const rangeBounds = (key) => {
  const now = new Date();
  const today = startOfDay(now);
  switch (key) {
    case "yesterday":
      return { from: new Date(today.getTime() - DAY_MS), to: today };
    case "7d":
      return { from: new Date(today.getTime() - 6 * DAY_MS), to: now };
    case "30d":
      return { from: new Date(today.getTime() - 29 * DAY_MS), to: now };
    default:
      return { from: today, to: now };
  }
};

// 22-9-2026 — design wala format.
export const formatShortDate = (d) => `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;

// "25 to 1 Oct" — 7/30 din ki range. Mahina sirf aakhri (chalu) tareekh ka.
export const formatDayRange = (from, to) =>
  `${from.getDate()} to ${to.getDate()} ${to.toLocaleString("en-US", { month: "short" })}`;

export const formatTime = (d) =>
  d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }).toUpperCase();

// "Today 10:12 AM" / "Yesterday 9:40 PM" / "18 Sep, 4:05 PM"
// `timeZone` (business ka) diya ho to din aur ghadi usi zone ki; na ho, ya naam
// galat ho (toLocaleString RangeError deta hai), to device ka zone.
export const formatActivityTime = (iso, timeZone) => {
  const d = new Date(iso);
  let zone = timeZone ? { timeZone } : {};
  try {
    d.toLocaleString("en-US", zone);
  } catch {
    zone = {};
  }
  const dayKey = (x) => x.toLocaleDateString("en-CA", zone); // YYYY-MM-DD us zone me
  const time = d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit", ...zone }).toUpperCase();
  const now = new Date();
  if (dayKey(d) === dayKey(now)) return `Today ${time}`;
  if (dayKey(d) === dayKey(new Date(now.getTime() - DAY_MS))) return `Yesterday ${time}`;
  return `${d.toLocaleString([], { day: "numeric", ...zone })} ${d.toLocaleString([], { month: "short", ...zone })}, ${time}`;
};

// +18548548545 → +1 (854)-854-8545. Doosre desh ka number jaisa aaya waisa.
export const formatPhone = (e164) => {
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(String(e164 || ""));
  return m ? `+1 (${m[1]})-${m[2]}-${m[3]}` : e164;
};

export const avatarSrc = (avatar) => {
  if (!avatar) return "/images/SofiaAgent.png";
  if (/^https?:\/\//.test(avatar) || avatar.startsWith("/")) return avatar;
  return `/${avatar}`;
};

// Pichhle 7 din (aaj samet) ke buckets + usse pehle ke 7 din ka total.
export const buildWeekSeries = (timestamps = []) => {
  const today = startOfDay(new Date());
  const days = Array.from({ length: 7 }, (_, i) => {
    const d = new Date(today.getTime() - (6 - i) * DAY_MS);
    return { start: d.getTime(), label: d.toLocaleString([], { weekday: "short" }), count: 0 };
  });
  const weekStart = days[0].start;
  const prevStart = weekStart - 7 * DAY_MS;
  let prevTotal = 0;
  timestamps.forEach((iso) => {
    const t = new Date(iso).getTime();
    if (t >= weekStart) {
      const idx = Math.min(6, Math.floor((t - weekStart) / DAY_MS));
      days[idx].count += 1;
    } else if (t >= prevStart) {
      prevTotal += 1;
    }
  });
  const total = days.reduce((s, d) => s + d.count, 0);
  // Pichhle hafte kuch nahi tha to % ka koi matlab nahi — dikhate hi nahi.
  const change = prevTotal > 0 ? Math.round(((total - prevTotal) / prevTotal) * 100) : null;
  return { days, total, change };
};
